import { call, put, takeEvery } from "redux-saga/effects";
import { DELETE_POLICY, GET_POLICY_LIST, UPLOAD_POLICY_DOC } from "./actionTypes";
import { onGettingPolicyList, onAddingPolicy, onDeletingPolicy } from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { addPolicyDocumentFail, addPolicyDocumentSuccess, deletePolicyFail, deletePolicySuccess, getPolicyListFail, getPolicyListSuccess } from "./action";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Privacy Policy";

function* onGetPolicyList({ payload: data }) {
  try {
    const response = yield call(onGettingPolicyList, data);
    yield put(getPolicyListSuccess(response));
  } catch (error) {
    yield put(getPolicyListFail(error));
    showToast("error", "Privacy Policy", error);
  }
}

function* onAddPolicy({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingPolicy, data);
    yield call(responseHandler, toastTitle, response, addPolicyDocumentSuccess, addPolicyDocumentFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addPolicyDocumentFail(error));
    showToast("error", "Privacy Policy", error);
  }
}

function* onDeletePolicy({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingPolicy, data);
    yield call(responseHandler, toastTitle, response, deletePolicySuccess, deletePolicyFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deletePolicyFail(error));
    showToast("error", "Privacy Policy", error);
  }
}

function* PrivacyPolicySaga() {
  yield takeEvery(GET_POLICY_LIST, onGetPolicyList);
  yield takeEvery(UPLOAD_POLICY_DOC, onAddPolicy);
  yield takeEvery(DELETE_POLICY, onDeletePolicy);
}

export default PrivacyPolicySaga;
